import { testimonials } from "@/mocks/positiveNews";

const principles = [
  { icon: "ri-eye-line", title: "内容真实", text: "来源可查、标注清楚，不夸大也不拔高。" },
  { icon: "ri-shield-check-line", title: "保护隐私", text: "涉及个人隐私的一律打码，尊重当事人意愿。" },
  { icon: "ri-heart-3-line", title: "克制表达", text: "讲清楚事实就好，不消费感动、不贩卖眼泪。" },
  { icon: "ri-seedling-line", title: "长期向善", text: "只做红料，让善意在反复阅读中被记住、被传递。" },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-16">
          {/* 关于本站 */}
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600">
              <span className="h-px w-6 bg-primary-400" />
              关于本站 · ABOUT US
            </p>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">我们为什么坚持只做红料</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              信息越喧嚣，越需要一点干净的光。红黑料正面爆料成立的初衷很简单：在铺天盖地的负面里，为愿意被温暖的人留一块地方。这里不追热点式的负能量，也不做夸张的煽情，只认真收集那些发生在普通人身边的善意——
              一次搀扶、一碗热饭、一次接力，然后安静地讲给你听。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              我们相信，被看见的善良会生长出更多善良。愿你每次打开这里，都能带走一点点继续向前的力气。
            </p>

            <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {principles.map((p) => (
                <div key={p.title} className="flex items-start gap-3 rounded-xl border border-background-200 bg-background-50 p-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                    <i className={`${p.icon} text-lg`} />
                  </span>
                  <div>
                    <h4 className="text-sm font-bold text-foreground-950">{p.title}</h4>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-600">{p.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 读者口碑 */}
          <div>
            <p className="mb-2 flex items-center gap-2 text-xs font-medium tracking-widest text-accent-600">
              <span className="h-px w-6 bg-accent-400" />
              读者口碑 · VOICES
            </p>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-4xl">他们说，这里是人间值得</h2>

            <div className="mt-6 flex flex-col gap-4">
              {testimonials.map((t) => (
                <figure key={t.name} className="rounded-2xl border border-background-200 bg-background-50 p-5">
                  <div className="flex items-center gap-1 text-accent-500">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm" />
                    ))}
                  </div>
                  <blockquote className="mt-3 text-sm leading-relaxed text-foreground-700">{t.text}</blockquote>
                  <figcaption className="mt-4 flex items-center gap-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-200 text-accent-700">
                      <i className="ri-user-smile-line" />
                    </span>
                    <div>
                      <div className="text-sm font-semibold text-foreground-950">{t.name}</div>
                      <div className="text-xs text-foreground-500">{t.role}</div>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}